import { makeStyles, createStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      paddingTop: theme.mixins.toolbar.minHeight,
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    list: {
      paddingInline: "10%",
    },
    container: {
      height: "100%",
    },
  })
);
